import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations'
import * as myGlobals from "../../../app.component";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx'; 
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { InstituteService } from 'src/app/Services/institute.service';
import { DatePipe } from '@angular/common';
import { InstituteDashboardDetailsService } from 'src/app/Services/institute-dashboard-details.service';
import { ToastrService } from 'ngx-toastr';

const EXCEL_TYPE='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION='.xlsx';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  // ApexXAxis,
  // ApexDataLabels,
  // ApexTitleSubtitle,
  // ApexStroke,
  // ApexFill,
  ApexGrid,
  ApexTooltip,
  ApexPlotOptions,
  // ApexNonAxisChartSeries,
  // ApexLegend,
  // ApexYAxis,
  // ApexAnnotations,
  // ApexResponsive,
  // ApexMarkers,
} from "ng-apexcharts";

export type GraphCharts = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  tooltip: ApexTooltip;
  grid: ApexGrid;
  plotOptions: ApexPlotOptions;
  colors: string[];
};

@Component({
  selector: 'app-student-assessment-details',
  templateUrl: './student-assessment-details.component.html',
  styleUrls: ['./student-assessment-details.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*', minHeight: "*" })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class StudentAssessmentDetailsComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  public TotalStudents: Partial<GraphCharts>;
  public RegisteredStudents: Partial<GraphCharts>;
  public GivenAssessments: Partial<GraphCharts>;
  public AverageScore: Partial<GraphCharts>;
  counts: any;

  displayedColumns = ['student_id', 'name', 'discipline', 'batch', 'assessment_type', 'assessment_date', 'view_report'];
  expandedElement: Element | null;
  dataSource = new MatTableDataSource<Element>();

  @ViewChild('paginator', { read: MatPaginator }) paginator: MatPaginator;
  @ViewChild('sort', { static: false }) sort: MatSort;

  constructor(
    private instituteService: InstituteService,
    private dashboardService:InstituteDashboardDetailsService,
    private toastr: ToastrService,
    private datepipe: DatePipe
    ) {

    this.TotalStudents = {
      series: [
        {
          name: "Total Students",
          data: []
        }
      ],
      chart: {
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        type: "bar",
        width: '100%',
        height: 80,
        sparkline: {
          enabled: true
        },
        toolbar: {
          show: false
        }
      },
      colors: ['#03586A'],
      plotOptions: {
        bar: {
          columnWidth: "80%"
        }
      },
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      }
    };
    this.RegisteredStudents = {
      series: [
        {
          name: "Total Students",
          data: []
        }
      ],
      chart: {
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        type: "bar",
        width: '100%',
        height: 80,
        sparkline: {
          enabled: true
        },
        toolbar: {
          show: false
        }
      },
      colors: ['#03586A'],
      plotOptions: {
        bar: {
          columnWidth: "80%"
        }
      },
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      }
    };
    this.GivenAssessments = {
      series: [
        {
          name: "Total Students",
          data: []
        }
      ],
      chart: {
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        type: "bar",
        width: '100%',
        height: 80,
        sparkline: {
          enabled: true
        },
        toolbar: {
          show: false
        }
      },
      colors: ['#03586A'],
      plotOptions: {
        bar: {
          columnWidth: "80%"
        }
      },
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      }
    };
    this.AverageScore = {
      series: [
        {
          name: "Total Students",
          data: []
        }
      ],
      chart: {
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        type: "bar",
        width: '100%',
        height: 80,
        sparkline: {
          enabled: true
        },
        toolbar: {
          show: false
        }
      },
      colors: ['#03586A'],
      plotOptions: {
        bar: {
          columnWidth: "80%"
        }
      },
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      }
    };

  }

  
  public baseUrl = myGlobals.baseFileUrl;
  public baseFileUrl = myGlobals.baseFileUrl;
  studentData:any=[];
  finalData:any=[];
  
  rating1 = ['active', '', '', '', ''];
  rating2 = ['active', 'active', '', '', ''];
  rating3 = ['active', 'active', 'active', '', ''];
  rating4 = ['active', 'active', 'active', 'active', ''];
  rating5 = ['active', 'active', 'active', 'active', 'active'];


  ngOnInit(): void {
    this.instituteService.getStudentAssessmentInstDashCounts().subscribe(data => this.setCounts(data['counts']));
    this.instituteService.getStudentAssessmentDetailsInstDashCounts().subscribe(data => this.setTableData(data['students']));
  }

  setCounts(data) {
    this.counts = data;
    // this.AverageScore.series[0]['data'] = data.averageScore['chartCounts'];
    this.TotalStudents.series['0']['data'] = data.totalStudents['chartCounts'];
    this.RegisteredStudents.series['0']['data'] = data.registeredStudents['chartCounts'];
    this.GivenAssessments.series['0']['data'] = data.assessmentCounts['chartCounts'];
  }

  setTableData(data){
    this.studentData=data;
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.filterPredicate = this.filterObject;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngAfterViewInit() {
    this.dataSource.filterPredicate = this.filterObject;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  filterObject(obj, filter):boolean{
    
    return filter.split(' ').some(
      item => obj['student_id'].toLowerCase().indexOf(item) >= 0 || 
              obj['name'].toLowerCase().indexOf(item) >= 0 || 
              obj['type'].toLowerCase().indexOf(item) >= 0 || 
              obj['course'].toLowerCase().indexOf(item) >= 0 || 
              obj['date_of_addmission'].toLowerCase().indexOf(item) >= 0
    );
  }

  navigateToReport(value) {
    // this.router.navigateByUrl('/student/view-assessment-report/' + value);
    const data = {
      assessmentId: value,
      download: true,
    };
    this.dashboardService
      .assessmentreportPdfForInstitute(data)
      .subscribe((data) =>this.handleReportNavigation(data));
  }

  handleReportNavigation(data){
    if(data['type']=='Success'){
      window.open(this.baseFileUrl + data['returnResponsePath'])
    }else{
      this.toastr.error(data['message']);
    }
  }

  public exportAsExcelFile(): void {
    this.finalData=[];
    this.studentData.forEach(element => {
      var assessment = {
        'Student ID': '', 'Name': '', 'Discipline': '', 'Batch': '', 
        'Assessment Type' : '', 'Assessment Date': ''
      };

      assessment['Student ID'] = element.student_id;
      assessment['Name'] = element.name;
      assessment['Discipline'] = element.course;
      assessment['Batch'] = element.date_of_addmission;
      assessment['Assessment Type'] = element.type;
      assessment['Assessment Date'] = this.datepipe.transform(element.created_at, 'dd-mm-yyyy');
      
      this.finalData.push(assessment);
    });

    var excelFileName= 'Students';
    var workbook: XLSX.WorkBook;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.finalData);
    workbook = { Sheets: { 'Students': worksheet }, SheetNames: ['Students'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}
